import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import '../styles/Header.css'

export default function Header() {
  const { user, loading, isAuthenticated, logout } = useAuth()

  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-container">
        <Link to="/" className="header-logo" data-testid="header-logo">
          Fingerstyle Studio
        </Link>

        <nav className="header-nav" data-testid="header-nav">
          <Link to="/courses/matticaspi" className="nav-link">
            הקורס
          </Link>
          {isAuthenticated && (
            <Link to="/submissions" className="nav-link">
              ההגשות שלי
            </Link>
          )}
          {isAuthenticated && user?.role === 'admin' && (
            <>
              <Link to="/admin/capsules" className="nav-link">
                Capsules
              </Link>
              <Link to="/admin/courses" className="nav-link">
                Manage Courses
              </Link>
              <Link to="/admin/reviews" className="nav-link">
                Reviews
              </Link>
            </>
          )}
        </nav>

        <div className="header-actions">
          {!loading && (
            isAuthenticated ? (
              <>
                <span className="header-user-email">{user?.email}</span>
                <button
                  className="btn btn-ghost btn-sm"
                  onClick={logout}
                >
                  התנתקות
                </button>
              </>
            ) : (
              <Link to="/login" className="nav-link">
                התחברות
              </Link>
            )
          )}
        </div>
      </div>
    </header>
  )
}
